import { Format } from "../../core/helpers/formatHelper";

export class Loader {

    /** Shows a spinner overlay on top of the element (appended to body,
     *  positioned over its rect). The component's DOM is never touched,
     *  so Vue re-renders, scoped CSS and v-for layouts are unaffected.
     *  The overlay also swallows clicks on the element while loading.
     */
    static Loading(id: string | null | undefined, css: any = null) {
        if (Format.IsNull(id)) {
            return;
        }

        const input = document.getElementById(id as string);
        if (input === null || input === undefined) {
            return;
        }

        if (document.getElementById("loader_" + id) !== null) {
            return;
        }

        const rect = input.getBoundingClientRect();
        if (rect.width === 0 && rect.height === 0) {
            return;
        }

        const overlay = document.createElement("div");
        overlay.id = "loader_" + id;
        overlay.className = "loader-overlay";
        overlay.style.left = (rect.left + window.pageXOffset) + "px";
        overlay.style.top = (rect.top + window.pageYOffset) + "px";
        overlay.style.width = rect.width + "px";
        overlay.style.height = rect.height + "px";

        const spinner = document.createElement("div");
        spinner.classList.add("spinnerButton");
        spinner.classList.add("background-main-color");
        overlay.appendChild(spinner);

        document.body.appendChild(overlay);
    }

    static Unloading(id: string | null | undefined) {
        if (Format.IsNull(id)) {
            return;
        }

        const overlay = document.getElementById("loader_" + id);
        if (overlay === null || overlay === undefined) {
            return;
        }

        (overlay.parentNode as Node).removeChild(overlay);
    }
}
